import { Component, OnInit, Input, ElementRef } from '@angular/core';

@Component({
    selector: 'app-dropdown-section',
    templateUrl: './dropdown-section.component.html',
    styleUrls: ['./dropdown-section.component.scss'],
    host: {
            '(document:click)': 'onClickOutside($event)',
    }
})
export class DropdownSectionComponent implements OnInit {

    public toggleSection: boolean;

    @Input() titleSection: string;
    @Input() openedByDefault: boolean;

    constructor(private eRef: ElementRef) { }

    ngOnInit() {
        this.toggleSection = this.openedByDefault ? true : false;
    }

    onClickOutside(event) {
        this.toggleSection = this.eRef.nativeElement.contains(event.target) ? true : false;
        // llencem l'event "load" de l'iframe perquè des del Drupal es recalculi l'alçada del contenidor.
        setTimeout(function(){ (<HTMLElement>window.parent.document.getElementById('simulador')).dispatchEvent(new Event('load')); }, 500);
    }
}